import { useEffect, useState } from 'react';
import { avancementLocal, ilotsEmportes, type IlotEmporte } from '../../terrain/ilots';
import { useSynchronisation } from '../../terrain/useTerrain';
import { Ligne, Liste, Section } from './commun';

/** Îlots de marché emportés pour le relevé et le recensement (D-303, D-305). */
export function IlotsEmportes() {
  const [ilots, setIlots] = useState<IlotEmporte[]>([]);
  const sync = useSynchronisation();
  useEffect(() => {
    let actif = true;
    void ilotsEmportes()
      .then((i) => {
        if (actif) setIlots(i);
      })
      .catch(() => {
        if (actif) setIlots([]);
      });
    return () => {
      actif = false;
    };
  }, [sync.revision]);
  if (!ilots.length) return null;
  return (
    <Section titre="Îlots de marché emportés">
      <Liste libelle="Îlots de marché">
        {ilots.map((e) => {
          const a = avancementLocal(e);
          return (
            <Ligne
              key={e.ilot.id}
              href={`/terrain/ilots/${e.ilot.id}`}
              titre={`Îlot ${e.ilot.code} · ${e.ilot.nom}`}
              sousTitre={`${a.recensees} places recensées sur ${a.places}`}
            />
          );
        })}
      </Liste>
    </Section>
  );
}
